export enum UserRole {
  student = 1,
  admin = 2,
  tutor = 3,
}
